import React from 'react';

export default function ValueRangeFilter({ valueMin, valueMax, onChange }) {
  return (
    <div>
      <label className="block text-xs font-medium text-text-muted mb-1">Стоимость (USD)</label>
      <div className="flex gap-2">
        <input
          type="number"
          value={valueMin || ''}
          onChange={e => onChange('valueMin', e.target.value || '')}
          placeholder="от"
          min="0"
          className="w-1/2 px-2.5 py-1.5 text-sm bg-app text-text-primary placeholder:text-text-disabled border border-border-default rounded-lg
                     focus:outline-none focus:ring-1 focus:ring-ring-focus"
        />
        <input
          type="number"
          value={valueMax || ''}
          onChange={e => onChange('valueMax', e.target.value || '')}
          placeholder="до"
          min="0"
          className="w-1/2 px-2.5 py-1.5 text-sm bg-app text-text-primary placeholder:text-text-disabled border border-border-default rounded-lg
                     focus:outline-none focus:ring-1 focus:ring-ring-focus"
        />
      </div>
    </div>
  );
}
